import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const EmailVerificationRibbon = ({ onNavigate }) => {
  const { isAuthenticated, user } = useAuth();

  // Only show if user is authenticated and email is not verified
  if (!isAuthenticated || !user || user.is_email_verified) {
    return null;
  }

  return (
    <div className="bg-green-50 border-l-4 border-green-400 py-2 px-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-4 w-4 text-green-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-green-700">
              <strong>Email verification required:</strong> Please check your email and click the verification link to activate your account.
            </p>
          </div>
        </div>
        <div className="ml-4 flex-shrink-0">
          <button
            onClick={() => onNavigate('verify-email', { email: user.email })}
            className="text-green-700 hover:text-green-800 text-sm font-medium underline transition-colors"
          >
            Resend Email
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationRibbon;
